import { useState, useContext } from "react";
import { Button, Container, Form, InputGroup, Spinner } from "react-bootstrap";
import { FaEnvelope, FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/css/Customer/CustomerAuth/CustomerLogin.css";
import logo from "../../../assets/images/logo.png";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const CustomerLogin = () => {
  const { baseUrl, RegExpChecker, setAuthToken } = useContext(AppContext);
  const [customerEmail, setcustomerEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setshowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  // Login par sirf email ki format validation, password ki strict validation signup par hai
  const [errors, setErrors] = useState({ email: "" });
  const navigate = useNavigate();

  const isFormValid = customerEmail && password && !errors.email;

  const handleLogin = () => {
    if (!isFormValid) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("customerEmail", customerEmail.trim());
    formData.append("password", password);

    // Content-Type header nahi lagana, axios FormData ke saath boundary khud set karta hai
    axios
      .post(`${baseUrl}/customer/profile/loginCustomer`, formData)
      .then((response) => {
        setLoading(false);
        if (response.data.success === true) {
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          localStorage.setItem("customerEmail", customerEmail.trim());
          localStorage.setItem(
            "tdcustomer",
            JSON.stringify(response.data.tdcustomer)
          );
          setcustomerEmail("");
          setPassword("");
          navigate("/customer-dashboard");
        } else {
          // Galat credentials par form clear nahi hota
          alert("Invalid Credentials. Try again with correct one.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  return (
    <div className="CustomerLogin-wrapper">
      <Container className="CustomerLogin-container">
        <div className="CustomerLogin-content">
          {/* Logo */}
          <div className="CustomerLogin-logo-container">
            <img src={logo} alt="logo" className="CustomerLogin-logo" />
          </div>

          {/* Welcome Text */}
          <p className="CustomerLogin-welcome-text">
            Hey, You have been missed!
          </p>

          {/* Login Form */}
          <div className="CustomerLogin-form">
            
            <div className="CustomerLogin-form-group mb-3">
              <Form.Label className="CustomerLogin-label">Email</Form.Label>
              <InputGroup className="CustomerLogin-input-group">
                <InputGroup.Text className="CustomerLogin-input-icon">
                  <FaEnvelope />
                </InputGroup.Text>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={customerEmail}
                  onChange={(e) => {
                    const value = e.target.value;
                    setcustomerEmail(value);

                    const regError = RegExpChecker("email", value.trim());
                    setErrors({ email: value && regError ? regError : "" });
                  }}
                  className="CustomerLogin-input"
                />
    
              </InputGroup>
              {errors.email && (
                <small className="text-danger">{errors.email}</small>
              )}
            </div>
            <div className="CustomerLogin-form-group mb-3">
              <Form.Label className="CustomerLogin-label">Password</Form.Label>
              <InputGroup className="CustomerLogin-input-group">
                <InputGroup.Text className="CustomerLogin-input-icon">
                  <FaLock />
                </InputGroup.Text>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="CustomerLogin-input"
                />
                <InputGroup.Text
                  className="CustomerLogin-input-icon CustomerLogin-password-toggle"
                  onClick={() => setshowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </InputGroup.Text>
              </InputGroup>
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="CustomerLogin-options mb-4">
              <Form.Check
                type="checkbox"
                label="Remember me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="CustomerLogin-checkbox"
              />
              <Button
                variant="link"
                className="customerLogin-forgot-btn"
                onClick={() => navigate("/customer-forgot-password")}
              >
                Forgot Password?
              </Button>
            </div>

            {/* Login Button */}
            <Button
              type="button"
              className="CustomerLogin-submit-btn mb-3"
              onClick={handleLogin}
              disabled={!isFormValid || loading}
            >
              {loading ? (
                <div className="btn-content-wrapper">
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="ms-2">Loading...</span>
                </div>
              ) : (
                "Login"
              )}
            </Button>

            {/* Sign Up Link */}
            <p className="CustomerLogin-signup-text">
              New User?
              <Link to="/customer-signup" className="CustomerLogin-signup-link">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CustomerLogin;